/**
 * form-data.js
 */


import { formatISO } from 'date-fns';


// helper to convert JSON object to FormData
// can handle nested objects, arrays and Files!
export function objectToFormData(obj, rootName, ignoreList) {
  var formData = new FormData();

  function appendFormData(data, root) {
    if (!ignore(root)) {
      root = root || "";

      // file object
      if (data instanceof File) {
        formData.append(root, data);
      } 

      // array
      else if (Array.isArray(data)) {
        appendFormData('', root + "[]");
        for (var i = 0; i < data.length; i++) {
          appendFormData(data[i], root + "[" + i + "]");
        }
      } 

      // date object
      else if (data && typeof data === "object" && typeof data.getMonth === "function") {
        formData.append(root, formatISO(data));
      }

      // dictionary object 
      else if (data && typeof data === "object") {
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            if (root === "") {
              appendFormData(data[key], key);
            } else {
              appendFormData(data[key], root + "." + key);
            }
          }
        }
      } 

      // primitive type
      else {
        if (data !== null && typeof data !== "undefined") {
          formData.append(root, data);
        }
      }
    }
  }

  function ignore(root) {
    return (
      Array.isArray(ignoreList)
      && ignoreList.includes(root.split('.').pop())
    );
  }

  appendFormData(obj, rootName);
  return formData;
}